import { render, staticRenderFns } from "./ScreenManage.vue?vue&type=template&id=211a3086&scoped=true&"
import script from "./ScreenManage.vue?vue&type=script&lang=js&"
export * from "./ScreenManage.vue?vue&type=script&lang=js&"
import style0 from "./ScreenManage.vue?vue&type=style&index=0&id=211a3086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a3086",
  null
  
)

export default component.exports